import React from 'react'



class DownloadPage extends React.Component {
    constructor(props) {
        super(props)
        var file_path = 'https://www.sorteflash.com/download/sorteflash-app.apk';
        var a = document.createElement('A');
        a.href = file_path;
        //a.download = file_path.substr(file_path.lastIndexOf('/') + 1);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }


    render() {
        return <h1>Baixando o App...</h1>
    }
}

export default DownloadPage